export default "__VITE_ASSET__DKYiN4V8__"